import React, { useMemo, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './styles';
import {
  setSelectedRestaurantList as setSelectedRestaurants
} from '../../../redux/actions/restaurantsActions';
import {
  getIsUserLoaded,
} from '../../../redux/selectors/userSelectors';

import { ShowRestaurantLists } from './ShowRestaurantLists';
import { useTranslation } from 'react-i18next';
import ShowSelectedRestaurants from './ShowSelectedRestaurants'
import ShowCorporateRestaurantList from './ShowCorporateRestaurantList';

/**
 * Used for all assignment modals
 * @param assignUnassignToRestaurants
 * @constructor
 */
interface RestaurantSelectionModalProps {
  openRestaurantModal: boolean;
  handleSelectedRestaurantsModal: Function;
  textValue?: string;
  actionOnSave?: Function;
  disabled?: boolean

}
const RestaurantSelectionModal = ({ openRestaurantModal, handleSelectedRestaurantsModal, textValue = 'OK', actionOnSave, disabled = true }: RestaurantSelectionModalProps) => {
  const dispatch: any = useDispatch();
  const classes = useStyles();
  let Profile: any = localStorage.getItem('profile') || "";

  if (Profile) {
    Profile = JSON.parse(Profile);
  }

  const isCorporateUser = Profile?.userType === 'corporate_admin';
  const selectedRestaurants = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.selectedRestaurantsList,
  );
  const isUserLoaded = useSelector(getIsUserLoaded);
  const [selectedRestaurantsList, updateSelectedRestaurants] = useState(selectedRestaurants)

  const hasRestaurantsSelected = useMemo(
    () => selectedRestaurantsList?.length > 0,
    [selectedRestaurantsList],
  );

  const canSave = useMemo(
    () => hasRestaurantsSelected,
    [hasRestaurantsSelected],
  );

  const handleClose = () => {
    handleSelectedRestaurantsModal();
  }

  const onClickSave = async () => {
    if (actionOnSave) actionOnSave(selectedRestaurantsList);
    dispatch(setSelectedRestaurants(selectedRestaurantsList));
    handleSelectedRestaurantsModal();
  };

  const handleRestaurantsSelectionChange = (values: any[]) => {
    updateSelectedRestaurants(values)
  };

  const { t } = useTranslation();

  return (
    <Dialog
      data-testid="restaurant-selection-modal"
      fullWidth
      maxWidth="md"
      open={openRestaurantModal}
      onClose={handleClose}
      aria-labelledby="max-width-dialog-title"
      disableBackdropClick={true}
    >
      <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
        <Grid container justifyContent='space-between'>
          <Grid item>
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              {t('home.assignment.selectedRestaurants')}
            </Typography>
          </Grid>
          <Grid item>
            <IconButton
              style={{ padding: 0 }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.tabPanel}>
          {isUserLoaded && (
            <Box
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'white',
              }}
              flexDirection="column"
              justifyContent="start"
            >
              <ShowSelectedRestaurants values={selectedRestaurantsList} onUpdate={(values) => updateSelectedRestaurants(values)} />
              {isCorporateUser ? <ShowCorporateRestaurantList value={selectedRestaurantsList}
                onChange={handleRestaurantsSelectionChange} /> :
                <ShowRestaurantLists value={selectedRestaurantsList}
                  onChange={handleRestaurantsSelectionChange} />}

            </Box>
          )}
        </div>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button variant="outlined" color="primary" onClick={handleClose}>
          {t('app.common.cancel')}
        </Button>
        <Button
          disabled={!canSave && disabled}
          variant="contained"
          color="primary"
          onClick={onClickSave}
        >
          {textValue ? textValue : t('operationHours.selectedRestaurants.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RestaurantSelectionModal;
